import type { BaseQueryFn } from "@reduxjs/toolkit/query";
import api from "../api";

export const customBaseQuery: BaseQueryFn<{
  url: string;
  method?: string;
  body?: unknown;
  params?: unknown;
}> = async (args) => {
  const { url, method = "GET", body, params } = args;

  try {
    const result = await api({
      url,
      method,
      data: body,
      params,
    });
    return { data: result.data };
  } catch (error: unknown) {
    const axiosError = error as {
      response?: { status?: number; data?: unknown };
      message?: string;
    };
    const fallbackMessage =
      error instanceof Error ? error.message : String(error);
    return {
      error: {
        status: axiosError.response?.status ?? 500,
        data:
          axiosError.response?.data ?? axiosError.message ?? fallbackMessage,
      },
    };
  }
};
